import { render, staticRenderFns } from "./CapturaDocumentoTipo.vue?vue&type=template&id=0e21c727&scoped=true&"
import script from "./CapturaDocumentoTipo.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoTipo.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoTipo.vue?vue&type=style&index=0&id=0e21c727&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e21c727",
  null
  
)

export default component.exports